// What's new — plain-language release notes, filtered to what this person can
// use. Entries live in lib/whatsNew.ts. Opening the page clears the sidebar's
// "New" tag (per browser).
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { fmtDayLong } from '../lib/dates';
import { markWhatsNewSeen, visibleWhatsNew, type WhatsNewEntry } from '../lib/whatsNew';
import { Badge } from '../components/primitives';
import { Card } from '../components/card';
import { useBelow } from '../lib/useMediaQuery';

export function WhatsNewScreen() {
  const { perms } = useAuth();
  const phone = useBelow('md');
  const entries = visibleWhatsNew(perms);
  useEffect(() => markWhatsNewSeen(perms), [perms]);

  const days = new Map<string, WhatsNewEntry[]>();
  for (const e of entries) days.set(e.date, [...(days.get(e.date) ?? []), e]);

  return (
    <div
      style={{
        padding: phone ? 'var(--hf-space-4)' : 'var(--hf-space-5)',
        display: 'flex',
        flexDirection: 'column',
        gap: 'var(--hf-space-4)',
        maxWidth: 720,
      }}
    >
      {[...days].map(([date, items]) => (
        <Card key={date} label={fmtDayLong(date)}>
          <ul
            style={{
              listStyle: 'none',
              margin: 0,
              padding: 0,
              display: 'flex',
              flexDirection: 'column',
              gap: 'var(--hf-space-4)',
            }}
          >
            {items.map((e) => (
              <li key={e.title} style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--hf-space-2)' }}>
                  <h3
                    style={{
                      margin: 0,
                      fontSize: 'var(--hf-text-sm)',
                      fontWeight: 500,
                      color: 'var(--hf-ink)',
                    }}
                  >
                    {e.title}
                  </h3>
                  {e.module && <Badge>{e.module[0].toUpperCase() + e.module.slice(1)}</Badge>}
                </div>
                <p
                  style={{
                    margin: 0,
                    fontSize: 'var(--hf-text-sm)',
                    lineHeight: 'var(--hf-leading-body)',
                    color: 'var(--hf-ink-3)',
                  }}
                >
                  {e.body}
                  {e.to && (
                    <>
                      {' '}
                      <Link
                        to={e.to}
                        aria-label={`Open: ${e.title}`}
                        style={{ color: 'var(--hf-accent-text)' }}
                      >
                        Open
                      </Link>
                    </>
                  )}
                </p>
              </li>
            ))}
          </ul>
        </Card>
      ))}
    </div>
  );
}
